"use client"

import HomeDetailsWrapperAccordion from "@/features/homeowners/components/home-details-wrapper-accordion"
import { useWorkscopeLabelStyle, WORKSCOPE_LABEL_COLORS } from "../home-details-wrapper-accordion"
import { workScopeStatusOptions } from "../../constants/options"

const goodwillGreenStyle = { color: WORKSCOPE_LABEL_COLORS.goodwill } as const
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import { useFormContext, useWatch } from "react-hook-form"
import FormSelectInput from "../../../../shared/components/form-inputs/form-select-input"
import WorkScopeStatusSelect from "../work-scope-status-select"
import FormMultiSelectInput from "../../../../shared/components/form-inputs/form-multi-select-input"
import FormTextInput from "@/shared/components/form-inputs/form-text-input"
import FormTextareaInput from "../../../../shared/components/form-inputs/form-textarea-input"
import DateStampedTextarea from "../../../../shared/components/form-inputs/form-date-stamped-textarea-input"
import { useClaimedByOptions } from "../../hooks/use-claimed-by-options"
import { useWorkscopeClaimedBySync } from "../../hooks/use-workscope-claimed-by-sync"
import { GoodwillToggleLabel } from "../goodwill-toggle-label"

const BASE_FIELD_NAME = "home.trimInstallInfo"

function HomeTrimInstallForm() {
    const goodwillLabelStyle = useWorkscopeLabelStyle(true) ?? goodwillGreenStyle
    const { control, setValue, getValues } = useFormContext<HomeWithHomeOwnerFormType>()
    const { options: claimedByOptions, loading: claimedByLoading } = useClaimedByOptions()
    const goodwillTrimInstallOn = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillTrimInstallOn` })
    
    // Watch status field and claimed by field
    const trimInstall = useWatch({ control, name: `${BASE_FIELD_NAME}.trimInstall` })
    const claimedBy = useWatch({ control, name: `${BASE_FIELD_NAME}.claimedBy` })
    const goodwillTrimInstall = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillTrimInstall` })
    const goodwillTrimInstallClaimedBy = useWatch({
        control,
        name: `${BASE_FIELD_NAME}.goodwillTrimInstallClaimedBy`,
    })

    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: trimInstall,
        claimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.claimedBy`,
        setValue,
        getValues,
    })
    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: goodwillTrimInstall,
        claimedBy: goodwillTrimInstallClaimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.goodwillTrimInstallClaimedBy`,
        setValue,
        getValues,
        enabled: !!goodwillTrimInstallOn,
    })
    return (
        <HomeDetailsWrapperAccordion 
            heading="Trim Install"
            wrapperClassName="xl:grid-cols-2"
        >
            <WorkScopeStatusSelect workScopeSlug="trim-install"
                inputGroupProps={{
                    label: <GoodwillToggleLabel title="Trim Install" toggleName={`${BASE_FIELD_NAME}.goodwillTrimInstallOn` as any} control={control} />,
                }}
                options={workScopeStatusOptions}
                name={`${BASE_FIELD_NAME}.trimInstall`}
                control={control}
            />
            <FormMultiSelectInput
                inputGroupProps={{
                    label: "Claimed By",
                }}
                options={claimedByOptions}
                name={`${BASE_FIELD_NAME}.claimedBy`}
                control={control}
                placeholder={claimedByLoading ? "Loading options..." : "Select"}
                searchPlaceholder="Search options..."
            />
            {goodwillTrimInstallOn && (
                <>
                    <FormSelectInput
                        inputGroupProps={{ label: "Trim Install Goodwill", labelStyle: goodwillLabelStyle }}
                        options={workScopeStatusOptions}
                        name={`${BASE_FIELD_NAME}.goodwillTrimInstall`}
                        control={control}
                    />
                    <FormMultiSelectInput
                        inputGroupProps={{ label: "Trim Install Goodwill Claimed By" }}
                        options={claimedByOptions}
                        name={`${BASE_FIELD_NAME}.goodwillTrimInstallClaimedBy`}
                        control={control}
                        placeholder={claimedByLoading ? "Loading options..." : "Select"}
                        searchPlaceholder="Search options..."
                    />
                </>
            )}
            <FormTextInput
                inputGroupProps={{
                    label: "How many linear feet of baseboard?",
                }}
                placeholder="How many linear feet of baseboard?"
                name={`${BASE_FIELD_NAME}.linearFeetOfBaseboard`}
                type="number"
                control={control}
            />
            <FormTextInput
                inputGroupProps={{
                    label: "How many linear feet of window casings?",
                }}
                placeholder="How many linear feet of window casings?"
                name={`${BASE_FIELD_NAME}.linearFeetOfWindowCasings`}
                type="number"
                control={control}
            />
            <DateStampedTextarea
                includeUserName
                inputGroupProps={{
                    label: "Description",
                    wrapperClassName: "xl:col-span-2"
                }}
                rows={3}
                placeholder="Describe the trim installation work needed"
                name={`${BASE_FIELD_NAME}.description`}
                control={control}
            />
        </HomeDetailsWrapperAccordion>
    )
}

export default HomeTrimInstallForm
